module.exports = __webpack_public_path__ + "static/media/3.84934b20.jpg";